import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ConflictResult, Contact } from '../models/conflict-result';
import { environment } from 'src/environments/environment';
import { DocumentUploadResponse } from '../models/document-upload-response';
import { Jurisdiction } from '../models/jurisdiction';
import { SearchType } from '../enums/search-type';
import { ConflictCheckSearchRequest } from '../models/conflict-check-search-request';
import { UpdateUboPercentage } from '../models/UpdateUboPercentage';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    selectedJurisdiction: string = "";
    conflictSearchTerm: string[] = [];
    searchClick: Subject<boolean> = new Subject<boolean>();
    private buttonVisibleSubject = new BehaviorSubject<boolean>(false);
    buttonVisible$ = this.buttonVisibleSubject.asObservable();

    constructor(private dataService: DataService) { }

    searchConflict(searchRequest: ConflictCheckSearchRequest): Observable<ConflictResult[]> {
        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
        var baseUrl = sessionStorage.getItem(environment.API_ENDPOINT);

        return this.dataService.post<ConflictResult[]>(`api/Conflict/search?accessToken=${accessToken}&baseUrl=${baseUrl}`, searchRequest);
    }

    setButtonVisibility(isVisible: boolean) {
        this.buttonVisibleSubject.next(isVisible);
    }

    getAllJurisdictions() {
        return this.dataService.get<Jurisdiction[]>(`api/Conflict/jurisdictions`);
    }

    updateJurisdictions(postData: UpdateUboPercentage[]) {
        return this.dataService.post<UpdateUboPercentage[]>(`api/Conflict/update-jurisdictions`, postData);
    }
}
